import React, {Fragment} from 'react';
import Select from './../Select';
import {Props} from '../Builder/ElementProperties';

const DropDownElement = (props) => {

	const onChange = (value) => { 
		props.element.value = value;
		props.experiment.recordEvent({eventType:'User Action', actionType:'change', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'dropdown', value: value, expectedValue: props.element.expected });
		props.experiment.forceUpdate(); 
	
		Props.onClickHandler({props, field:'onClick'});
	};

	return (
		<Select
			label={props.element.label}
			value={props.element.value}
			onChange={ onChange }
			onSameValueChange={ onChange }
			options={props.element.options}
			newRow
			fullwidth
			margin={'none'}
			/>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.Label {...props} />
		<Props.Options {...props} />
		<Props.Expected {...props} />
		<Props.OnClick {...props} />
	</Fragment>
);

DropDownElement.type = 'dropdown';
DropDownElement.Properties = Properties;
DropDownElement.defaultJSON = {type: 'dropdown', id:'New Drop Down', x: 250, y:250, width:200, height:60, label:'New Drop Down',  onClick:'', options:['Option 1', 'Option 2'], expected: ''};
export default DropDownElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/DropDownElement.js